import React, { useEffect, useState } from 'react';
import { ref, onValue, get, remove } from 'firebase/database';
import { database } from '../../firebaseConfig';
import { useAuth } from '../../context/AuthContext';
import { setSharing } from '../../services/recordAccess';
import { ui } from './crmUi';

// Requests from teammates who tried to add a person that is already one of your private contacts.
// You decide: Share (it shows in their Contacts too) or Decline. Nothing is shared automatically.
export default function ShareRequests({ nameOf = (u) => u }) {
  const { user, userRole } = useAuth();
  const uid = user?.uid;
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState('');
  useEffect(() => (uid ? onValue(ref(database, `crm/shareRequests/${uid}`), (s) => setRows(Object.entries(s.val() || {}).map(([id, v]) => ({ id, ...v }))), () => setRows([])) : undefined), [uid]);
  if (!rows.length) return null;
  const done = (r) => remove(ref(database, `crm/shareRequests/${uid}/${r.id}`));
  const share = async (r) => {
    try {
      const snap = await get(ref(database, `crm/contacts/${r.contactId}`));
      if (!snap.exists()) { await done(r); return; }
      await setSharing('contacts', { id: r.contactId, ...snap.val() }, { add: [r.fromUid] }, uid, userRole === 'Admin', nameOf);
      await done(r); setMsg(`Shared with ${r.fromName || nameOf(r.fromUid)}.`);
    } catch (e) { setMsg(e.message); }
  };
  return (
    <div style={{ ...ui.card, background: '#FFF9E6', border: '1px solid #D4AF37', marginBottom: 10 }}>
      <strong>Share requests</strong>
      {rows.map((r) => (
        <div key={r.id} style={{ ...ui.row, justifyContent: 'space-between', marginTop: 6 }}>
          <span>{r.fromName || nameOf(r.fromUid)} tried to add <a href={`/leads/contacts?id=${r.contactId}`}>{r.contactName || 'one of your contacts'}</a> and asked you to share it.</span>
          <span style={ui.row}><button style={ui.btn} onClick={() => share(r)}>Share</button><button style={ui.ghost} onClick={() => done(r)}>Decline</button></span>
        </div>
      ))}
      {msg && <p style={{ fontSize: 13 }}>{msg}</p>}
    </div>
  );
}
